// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormCategory } from '~/utils/interface/category';
import { EMPTY_STRING } from '~/utils/constants/common';

export const schema = (t: TFunction): yup.ObjectSchema<IFormCategory> => {
  return yup.object().shape({
    name: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    description: yup.string().optional(),
    categoryImage: yup.object().optional(),
  });
};

export const defaultValuesCategoryForm: IFormCategory = {
  name: EMPTY_STRING,
};
